<template>
	<v-row no-gutters align="center">
		<v-col cols="auto" class="text-left field_name">
			<h2 class="med pr-3 pl-1">App</h2>
		</v-col>
		<v-col class="text-left" v-if="selectedApp">
			<v-row no-gutters align="center" class="s_app">
				<v-col cols="auto">
					<v-card class="ac_card inline-block" style="border-radius: 4px !important">
						<div class="centerdXY">
							<SIcon :width="12" :name="selectedApp.service_slug" />
						</div>
					</v-card>
				</v-col>
				<v-col class="pl-3" cols="auto">
					<h3>{{ selectedApp.service_name }}</h3>
				</v-col>
				<v-col class="chg_area text-left pl-3">
					<v-btn rounded outlined color="#D1D9E9" class="chg" height="30px" @click="showSelectAppScreen">Change</v-btn>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'BlockEditorIntegrationApp',
	props: {},
	data: () => ({}),
	mounted() {},
	components: {},
	watch: {},
	computed: {
		...mapGetters(['selectedNode/editNode', 'apps/getService']),
		selectedApp() {
			return this['apps/getService'](this['selectedNode/editNode'].service);
		},
	},
	methods: {
		showSelectAppScreen() {
			this.$emit('showSelectAppScreen');
		},
	},
};
</script>

<style scoped>
.integration {
}
.integration .field_name {
	min-width: 70px;
}
h2.med {
	font-size: 16px;
	font-weight: 600;
	color: #292829;
}
.ac {
	border-radius: 4px !important;
	border-color: #d6ddeb;
}
.ac_card {
	width: 25px;
	height: 25px;
	border-radius: 7px !important;
	transition: all 0.3s ease-in-out;
}
h3.tit {
	color: #5c8df5;
	font-weight: 500;
	font-size: 14px;
}
h5.desc {
	font-size: 12px;
	font-weight: 300;
	color: #464b57;
}
.v-list-item {
	padding: 0px;
}
h3 {
	color: #354052;
	font-size: 14px;
	font-weight: 400;
}

.chg_area {
	opacity: 0;
}
.s_app:hover .chg_area {
	opacity: 1;
}
</style>
